import { Injectable } from '@angular/core';
import { Observable, Subject, fromEvent, asyncScheduler } from 'rxjs';
import { filter, observeOn, takeUntil } from 'rxjs/operators';
import { CustomRxEvent } from '../models/lab-broker-event.model';

@Injectable({ providedIn: 'root' })
export class LabBrokerCommunicationService {
	private iframeWindow: Window | null = null;
	private iframeUrl: string | null = null;
	private expectedOrigin: string | null = null;
	private readonly stopSubject = new Subject<void>();

	private readonly iframeMessages$ = fromEvent<MessageEvent>(window, 'message').pipe(observeOn(asyncScheduler));

	listenToEvents(): Observable<MessageEvent<CustomRxEvent<unknown>>> {
		return this.iframeMessages$.pipe(
			filter(event => this.isFromLabBrokerIframe(event)),
			takeUntil(this.stopSubject)
		);
	}

	setExpectedOrigin(iframeUrl: string): void {
		try {
			this.expectedOrigin = new URL(iframeUrl).origin;
		} catch {
			this.expectedOrigin = null;
		}
	}

	setIframeWindow(win: Window | null, iframeUrl: string): void {
		this.iframeWindow = win;
		this.iframeUrl = iframeUrl;
	}

	sendEvent(event: CustomRxEvent<unknown>): void {
		if (!this.iframeWindow || !this.iframeUrl) {
			return;
		}

		const targetOrigin = new URL(this.iframeUrl).origin;

		this.iframeWindow.postMessage(event, targetOrigin);
	}

	teardown(): void {
		this.stopSubject.next();
		this.iframeWindow = null;
		this.iframeUrl = null;
		this.expectedOrigin = null;
	}

	private isFromLabBrokerIframe(event: MessageEvent): boolean {
		if (!this.expectedOrigin) {
			return false;
		}

		return event.origin === this.expectedOrigin;
	}
}
